// export const taskToSubdrivingQuestionSolarzellen = [
//    { _id: 1, drivingQuestion: 'Solarzellen auf Hausdächern', tasks: ['01', '02'] },
//     {
//       _id: 2,
//       drivingQuestion:
//         'Warum befinden sich so viele Solarzellen auf Dächern von Häusern?',
//       tasks: ['03', '04', '05', '06', '07', '08'],
//     },
//     { _id: 3, drivingQuestion: 'Wie sollten Solarzellen am Dach angebracht sein', tasks: ['09','10','11','12','13','14','15','16','17'] },
//     { _id: 4, drivingQuestion: 'Warum richten wir Solarzellen nicht immer nach dem Sonnenstand aus?', tasks: ['18','19','20','21','22','23','24','25','26','27','28','29','30','31','32'] },
//     { _id: 5, drivingQuestion: 'Was hast du gelernt?', tasks: ['33','34','35','36'] },
//   ];

//   export const taskToSubdrivingQuestionLaptop = [
//     { _id: 1, drivingQuestion: 'Alltägliche Probleme mit einem Laptop', tasks: ['01','02'] },
//     { _id: 2, drivingQuestion: 'Wo wird ein Laptop heiß?', tasks: ['03','04','05','06','07','08','09'] },
//     { _id: 3, drivingQuestion: 'Wann wird ein Laptop heiß?', tasks: ['10','11','12','13','14','15'] },
//     { _id: 4, drivingQuestion: 'Was hast du gelernt?', tasks: ['16','17','18','19','20','21','22','23','24','25'] },
//     { _id: 5, drivingQuestion: 'Was hast du gelernt?', tasks: ['26','27','28','29','30','31'] },
//   ];

export const mappingCourseGroupId = {
  Solarzellen: [
    '377',
    '375',
    '372',
    '339',
    '340',
    '341',
    '342',
    '343',
    '344',
    '345',
    '346',
    '347',
    '348',
    '349',
    '350',
    '351',
    '352',
    '353',
    '354',
    '355',
    '356',
    '357',
    '358',
    '109',
  ],
  Laptop: ['103', '364', '366', '373', '367', '368'],
};

export const taskDocs = [
  {
    _id: '1',
    _class: 'Tasks',
    taskName: 'Laptop_ProblemeeinesLaptops_0',
    courseGroup: 'Laptop',
    moodleTaskId: '01',
    goalids: [5],
    taskType: 'essay',
  },
  {
    _id: '2',
    _class: 'Tasks',
    taskName: 'Laptop_ErklärungendesheißwerdendenLaptops_0',
    courseGroup: 'Laptop',
    moodleTaskId: '02',
    goalids: [1, 3, 4, 5, 8, 9],
    taskType: 'essay',
  },
  {
    _id: '3',
    _class: 'Tasks',
    taskName: 'Laptop_AufschraubeneinesLaptops_1',
    courseGroup: 'Laptop',
    moodleTaskId: '03',
    goalids: [3, 5],
    taskType: 'essay',
  },
  {
    _id: '4',
    _class: 'Tasks',
    taskName: 'Laptop_EinheißesElementimLaptop_0',
    courseGroup: 'Laptop',
    moodleTaskId: '04',
    goalids: [1],
    taskType: 'multichoice',
  },
  {
    _id: '5',
    _class: 'Tasks',
    taskName: 'Laptop_Stromkreisexperiment(ExperimentfürSchüler/innen)_1',
    courseGroup: 'Laptop',
    moodleTaskId: '05',
    goalids: [6],
    taskType: 'essay',
  },
  {
    _id: '6',
    _class: 'Tasks',
    taskName: 'Laptop_Stromkreisexperiment(ExperimentfürSchüler/innen)_2',
    courseGroup: 'Laptop',
    moodleTaskId: '06',
    goalids: [7],
    taskType: 'essay',
  },
  {
    _id: '7',
    _class: 'Tasks',
    taskName: 'Laptop_Stromkreisexperiment(ExperimentfürSchüler/innen)_3',
    courseGroup: 'Laptop',
    moodleTaskId: '07',
    goalids: [1, 2, 3],
    taskType: 'multichoice',
  },
  {
    _id: '8',
    _class: 'Tasks',
    taskName: 'Laptop_Stromkreisexperiment(ExperimentfürSchüler/innen)_4',
    courseGroup: 'Laptop',
    moodleTaskId: '08',
    goalids: [1, 3, 4, 5, 8, 9],
    taskType: 'essay',
  },
  {
    _id: '9',
    _class: 'Tasks',
    taskName: 'Laptop_1.Zusammenfassung_0',
    courseGroup: 'Laptop',
    moodleTaskId: '09',
    goalids: [1, 3, 9],
    taskType: 'essay',
  },
  {
    _id: '10',
    _class: 'Tasks',
    taskName: 'Laptop_WannwirdeinLaptopmanchmalheiß?_0',
    courseGroup: 'Laptop',
    moodleTaskId: '10',
    goalids: [9],
    taskType: 'essay',
  },
  {
    _id: '11',
    _class: 'Tasks',
    taskName: 'Laptop_ExperimentineinemStromkreis2.0(Schülerexperiment)_1',
    courseGroup: 'Laptop',
    moodleTaskId: '11',
    goalids: [6],
    taskType: 'essay',
  },

  {
    _id: '12',
    _class: 'Tasks',
    taskName: 'Laptop_ExperimentineinemStromkreis2.0(Schülerexperiment)_2',
    courseGroup: 'Laptop',
    moodleTaskId: '12',
    goalids: [1, 3, 4, 5, 7, 8, 9],
    taskType: 'essay',
  },
  {
    _id: '13',
    _class: 'Tasks',
    taskName: 'Laptop_ExperimentineinemStromkreis2.0(Demonstrationsexperiment)_1',
    courseGroup: 'Laptop',
    moodleTaskId: '13',
    goalids: [6],
    taskType: 'essay',
  },
  {
    _id: '14',
    _class: 'Tasks',
    taskName: 'Laptop_ExperimentineinemStromkreis2.0(Demonstrationsexperiment)_2',
    courseGroup: 'Laptop',
    moodleTaskId: '14',
    goalids: [1, 3, 4, 7, 5, 8, 9],
    taskType: 'essay',
  },
  {
    _id: '15',
    _class: 'Tasks',
    taskName: 'Laptop_2.Zusammenfassung_0',
    courseGroup: 'Laptop',
    moodleTaskId: '15',
    goalids: [1, 3, 4, 5, 8, 9],
    taskType: 'essay',
  },
  {
    _id: '16',
    _class: 'Tasks',
    taskName: 'Laptop_EinwichtigesBauteilimLaptop(ExperimentfürSchüler/innen)_2',
    courseGroup: 'Laptop',
    moodleTaskId: '16',
    goalids: [6],
    taskType: 'essay',
  },
  {
    _id: '17',
    _class: 'Tasks',
    taskName: 'Laptop_EinwichtigesBauteilimLaptop(ExperimentfürSchüler/innen)_3',
    courseGroup: 'Laptop',
    moodleTaskId: '17',
    goalids: [7],
    taskType: 'essay',
  },
  {
    _id: '18',
    _class: 'Tasks',
    taskName: 'Laptop_EinwichtigesBauteilimLaptop(ExperimentfürSchüler/innen)_4',
    courseGroup: 'Laptop',
    moodleTaskId: '18',
    goalids: [7],
    taskType: 'essay',
  },
  {
    _id: '19',
    _class: 'Tasks',
    taskName: 'Laptop_EinwichtigesBauteilimLaptop(ExperimentfürSchüler/innen)_5',
    courseGroup: 'Laptop',
    moodleTaskId: '19',
    goalids: [1, 3, 4, 5, 8, 9],
    taskType: 'essay',
  },
  {
    _id: '20',
    _class: 'Tasks',
    taskName: 'CRU04_Ein wichtiges Bauteil im Laptop (Demonstrationsexperiment)_2',
    courseGroup: 'Laptop',
    moodleTaskId: '20',
    goalids: [6],
    taskType: 'essay',
  },
  {
    _id: '21',
    _class: 'Tasks',
    taskName: 'CRU04_Ein wichtiges Bauteil im Laptop (Demonstrationsexperiment)_3',
    courseGroup: 'Laptop',
    moodleTaskId: '21',
    goalids: [7],
    taskType: 'essay',
  },
  {
    _id: '22',
    _class: 'Tasks',
    taskName: 'CRU06_Ein wichtiges Bauteil im Laptop (Demonstrationsexperiment)_4',
    courseGroup: 'Laptop',
    moodleTaskId: '22',
    goalids: [7],
    taskType: 'essay',
  },
  {
    _id: '23',
    _class: 'Tasks',
    taskName: 'CRU04_Ein wichtiges Bauteil im Laptop (Demonstrationsexperiment)_5',
    courseGroup: 'Laptop',
    moodleTaskId: '23',
    goalids: [1, 3, 4, 5, 8, 9],
    taskType: 'essay',
  },
  {
    _id: '24',
    _class: 'Tasks',
    taskName: 'Laptop_FrühereLaptopsvs.heutigeLaptops_0',
    courseGroup: 'Laptop',
    moodleTaskId: '24',
    goalids: [1, 3, 4],
    taskType: 'gapselect',
  },
  {
    _id: '25',
    _class: 'Tasks',
    taskName: 'Laptop_3.Zusammenfassung_0',
    courseGroup: 'Laptop',
    moodleTaskId: '25',
    goalids: [1, 3, 4, 5, 8, 9],
    taskType: 'essay',
  },
  {
    _id: '26',
    _class: 'Tasks',
    taskName: 'Laptop_Zusammenfassung_0',
    courseGroup: 'Laptop',
    moodleTaskId: '26',
    goalids: [1, 3, 4, 5, 8, 9],
    taskType: 'essay',
  },
  {
    _id: '27',
    _class: 'Tasks',
    taskName: 'Laptop_Zusammenfassung_1',
    courseGroup: 'Laptop',
    moodleTaskId: '27',
    goalids: [],
    taskType: 'essay',
  },
  {
    _id: '28',
    _class: 'Tasks',
    taskName: 'Laptop_Zusammenfassung_2',
    courseGroup: 'Laptop',
    moodleTaskId: '28',
    goalids: [],
    taskType: 'multichoice',
  },
  {
    _id: '29',
    _class: 'Tasks',
    taskName: 'Laptop_Zusammenfassung_3',
    courseGroup: 'Laptop',
    moodleTaskId: '29',
    goalids: [1, 3, 4],
    taskType: 'multichoice',
  },
  {
    _id: '30',
    _class: 'Tasks',
    taskName: 'Laptop_Zusammenfassung_4',
    courseGroup: 'Laptop',
    moodleTaskId: '30',
    goalids: [4],
    taskType: 'multichoice',
  },
  {
    _id: '31',
    _class: 'Tasks',
    taskName: 'Laptop_Zusammenfassung_5',
    courseGroup: 'Laptop',
    moodleTaskId: '31',
    goalids: [],
    taskType: 'essay',
  },

  //Solarzellen
  //
  {
    _id: '32',
    _class: 'Tasks',
    taskName: 'Solarzelle_HäusermitSolarzellen_1',
    courseGroup: 'Solarzellen',
    moodleTaskId: '01',
    goalids: [6],
    taskType: 'essay',
  },

  // 1,2,3,4 --> bleibt gleich
  // 5 --> 7
  // 6 -->8
  // 7--> 5
  // 8 -->6

  {
    _id: '33',
    _class: 'Tasks',
    taskName: 'Solarzelle_Erklärungfür einemöglichstguteEnergieumwandlung_0',
    courseGroup: 'Solarzellen',
    moodleTaskId: '02',
    goalids: [1, 2, 3, 4, 7, 8],
    taskType: 'essay',
  },
  {
    _id: '34',
    _class: 'Tasks',
    taskName: 'Solarzellen_ExperimentmiteinerSolarzelle_0',
    courseGroup: 'Solarzellen',
    moodleTaskId: '03',
    goalids: [1, 2, 3],
    taskType: 'gapselect',
  },

  {
    _id: '35',
    _class: 'Tasks',
    taskName: 'Solarzellen_ExperimentmiteinerSolarzelle_2',
    courseGroup: 'Solarzellen',
    moodleTaskId: '04',
    goalids: [5],
    taskType: 'essay',
  },
  {
    _id: '36',
    _class: 'Tasks',
    taskName: 'Solarzellen_ExperimentmiteinerSolarzelle_3',
    courseGroup: 'Solarzellen',
    moodleTaskId: '05',
    goalids: [6],
    taskType: 'essay',
  },
  {
    _id: '37',
    _class: 'Tasks',
    taskName: 'Solarzellen_ExperimentmiteinerSolarzelle_4',
    courseGroup: 'Solarzellen',
    moodleTaskId: '06',
    goalids: [6],
    taskType: 'essay',
  },
  {
    _id: '38',
    _class: 'Tasks',
    taskName: 'Solarzellen_ExperimentmiteinerSolarzelle_5',
    courseGroup: 'Solarzellen',
    moodleTaskId: '07',
    goalids: [1, 2, 3],
    taskType: 'multianswer',
  },
  {
    _id: '39',
    _class: 'Tasks',
    taskName: 'Solarzellen_1.Zusammenfassung_0',
    courseGroup: 'Solarzellen',
    moodleTaskId: '08',
    goalids: [1, 2, 3, 4, 7, 8],
    taskType: 'essay',
  },
  {
    _id: '40',
    _class: 'Tasks',
    taskName: 'Solarzellen_ExperimentzurAusrichtungvonSolarzellen_1',
    courseGroup: 'Solarzellen',
    moodleTaskId: '09',
    goalids: [5],
    taskType: 'essay',
  },
  {
    _id: '41',
    _class: 'Tasks',
    taskName: 'Solarzellen_ExperimentzurAusrichtungvonSolarzellen_2',
    courseGroup: 'Solarzellen',
    moodleTaskId: '10',
    goalids: [1, 2, 3, 4, 7, 8],
    taskType: 'essay',
  },
  {
    _id: '42',
    _class: 'Tasks',
    taskName: 'Solarzellen_ExperimentzurAusrichtungvonSolarzellen_3',
    courseGroup: 'Solarzellen',
    moodleTaskId: '11',
    goalids: [2],
    taskType: 'essay',
  },
  {
    _id: '43',
    _class: 'Tasks',
    taskName: 'Solarzellen_ExperimentzurAusrichtungvonSolarzellen_4',
    courseGroup: 'Solarzellen',
    moodleTaskId: '12',
    goalids: [2],
    taskType: 'essay',
  },
  {
    _id: '44',
    _class: 'Tasks',
    taskName: 'Solarzellen_ExperimentzurAusrichtungvonSolarzellen_5',
    courseGroup: 'Solarzellen',
    moodleTaskId: '13',
    goalids: [2],
    taskType: 'essay',
  },
  {
    _id: '45',
    _class: 'Tasks',
    taskName: 'Solarzellen_ExperimentzurAusrichtungvonSolarzellen_6',
    courseGroup: 'Solarzellen',
    moodleTaskId: '14',
    goalids: [2],
    taskType: 'essay',
  },
  {
    _id: '46',
    _class: 'Tasks',
    taskName: 'Solarzellen_ExperimentzurAusrichtungvonSolarzellen_7',
    courseGroup: 'Solarzellen',
    moodleTaskId: '15',
    goalids: [2, 4, 8],
    taskType: 'essay',
  },
  {
    _id: '47',
    _class: 'Tasks',
    taskName: 'Solarzellen_QuizzurAusrichtungvonSolarzellen_0',
    courseGroup: 'Solarzellen',
    moodleTaskId: '16',
    goalids: [2],
    taskType: 'multianswer',
  },
  {
    _id: '48',
    _class: 'Tasks',
    taskName: 'Solarzellen_2.Zusammenfassung_0',
    courseGroup: 'Solarzellen',
    moodleTaskId: '17',
    goalids: [2, 4, 8],
    taskType: 'essay',
  },
  {
    _id: '49',
    _class: 'Tasks',
    taskName: 'Solarzellen_ExperimentzurNachrichtungvonSolarzellen_0',
    courseGroup: 'Solarzellen',
    moodleTaskId: '18',
    goalids: [5],
    taskType: 'essay',
  },
  {
    _id: '50',
    _class: 'Tasks',
    taskName: 'Solarzellen_ExperimentzurNachrichtungvonSolarzellen_1',
    courseGroup: 'Solarzellen',
    moodleTaskId: '19',
    goalids: [4],
    taskType: 'essay',
  },
  {
    _id: '51',
    _class: 'Tasks',
    taskName: 'Solarzellen_ExperimentzurNachrichtungvonSolarzellen_2',
    courseGroup: 'Solarzellen',
    moodleTaskId: '20',
    goalids: [1, 2, 3, 4, 7, 8],
    taskType: 'essay',
  },
  {
    _id: '52',
    _class: 'Tasks',
    taskName: 'Solarzellen_ExperimentzurVerschattungvonSolarzellen_0',
    courseGroup: 'Solarzellen',
    moodleTaskId: '21',
    goalids: [5],
    taskType: 'essay',
  },
  {
    _id: '53',
    _class: 'Tasks',
    taskName: 'Solarzellen_ExperimentzurVerschattungvonSolarzellen_1',
    courseGroup: 'Solarzellen',
    moodleTaskId: '22',
    goalids: [8],
    taskType: 'essay',
  },
  {
    _id: '54',
    _class: 'Tasks',
    taskName: 'Solarzellen_ExperimentzurVerschattungvonSolarzellen_2',
    courseGroup: 'Solarzellen',
    moodleTaskId: '23',
    goalids: [1, 2, 3, 4, 7, 8],
    taskType: 'essay',
  },
  {
    _id: '55',
    _class: 'Tasks',
    taskName: 'Solarzellen_QuizzurVerschattungvonSolarzellen_1',
    courseGroup: 'Solarzellen',
    moodleTaskId: '24',
    goalids: [2],
    taskType: 'truefalse',
  },
  {
    _id: '56',
    _class: 'Tasks',
    taskName: 'Solarzellen_QuizzurVerschattungvonSolarzellen_2',
    courseGroup: 'Solarzellen',
    moodleTaskId: '25',
    goalids: [2],
    taskType: 'truefalse',
  },
  {
    _id: '57',
    _class: 'Tasks',
    taskName: 'Solarzellen_QuizzurVerschattungvonSolarzellen_3',
    courseGroup: 'Solarzellen',
    moodleTaskId: '26',
    goalids: [2],
    taskType: 'truefalse',
  },
  {
    _id: '58',
    _class: 'Tasks',
    taskName: 'Solarzellen_QuizzurVerschattungvonSolarzellen_4',
    courseGroup: 'Solarzellen',
    moodleTaskId: '27',
    goalids: [2],
    taskType: 'truefalse',
  },
  {
    _id: '59',
    _class: 'Tasks',
    taskName: 'Solarzellen_QuizzurVerschattungvonSolarzellen_5',
    courseGroup: 'Solarzellen',
    moodleTaskId: '28',
    goalids: [2],
    taskType: 'truefalse',
  },
  {
    _id: '60',
    _class: 'Tasks',
    taskName: 'Solarzellen_QuizzurVerschattungvonSolarzellen_6',
    courseGroup: 'Solarzellen',
    moodleTaskId: '29',
    goalids: [2],
    taskType: 'truefalse',
  },
  {
    _id: '61',
    _class: 'Tasks',
    taskName: 'Solarzellen_QuizzurVerschattungvonSolarzellen_7',
    courseGroup: 'Solarzellen',
    moodleTaskId: '30',
    goalids: [2],
    taskType: 'truefalse',
  },
  {
    _id: '62',
    _class: 'Tasks',
    taskName: 'Solarzellen_QuizzurVerschattungvonSolarzellen_8',
    courseGroup: 'Solarzellen',
    moodleTaskId: '31',
    goalids: [2],
    taskType: 'truefalse',
  },
  {
    _id: '63',
    _class: 'Tasks',
    taskName: 'Solarzellen_3.Zusammenfassung_0',
    courseGroup: 'Solarzellen',
    moodleTaskId: '32',
    goalids: [1, 2, 3, 4, 7, 8],
    taskType: 'essay',
  },
  {
    _id: '64',
    _class: 'Tasks',
    taskName: 'Solarzellen_Zusammenfassung_0',
    courseGroup: 'Solarzellen',
    moodleTaskId: '33',
    goalids: [1, 2, 3, 4, 7, 8],
    taskType: 'essay',
  },
  {
    _id: '65',
    _class: 'Tasks',
    taskName: 'Solarzellen_Zusammenfassung_2',
    courseGroup: 'Solarzellen',
    moodleTaskId: '34',
    goalids: [1, 2, 3],
    taskType: 'multichoice',
  },
  {
    _id: '66',
    _class: 'Tasks',
    taskName: 'Solarzellen_Zusammenfassung_1',
    courseGroup: 'Solarzellen',
    moodleTaskId: '35',
    goalids: [1, 2, 3],
    taskType: 'multichoice',
  },
  {
    _id: '67',
    _class: 'Tasks',
    taskName: 'Solarzellen_Zusammenfassung_3',
    courseGroup: 'Solarzellen',
    moodleTaskId: '36',
    goalids: [],
    taskType: 'essay',
  },
];

export const goalDocs = [
  {
    _id: 'Laptop_1',
    _class: 'Goals',
    courseGroup: 'Laptop',
    goalNumber: '1',
    goalTitle: 'Elektrische Energie (Wissen)',
    goalText:
      'Fachwissen zur elektrischen Energie: SuS können den Begriff "Elektrische Energie" verwenden oder Indikatoren für Elektische Energie (wie z.B. Strom) verwenden.',
    goalLevel: '0',
    oldNLPgoals: ['M.Electric-Energy', 'M.Electric-variable'],
  },

  {
    _id: 'Laptop_2',
    _class: 'Goals',
    courseGroup: 'Laptop',
    goalNumber: '2',
    goalTitle: 'Strahlungsenergie (Wissen)',
    goalText:
      'Fachwissen zur Strahlungsenergie: SuS können den Begriff "Strahlungsenergie" verwenden oder Indikatoren für Strahlungsenergie (wie z.B. Licht) verwenden.',
    goalLevel: '0',
    oldNLPgoals: ['M.Radiant-Energy', 'M.Radiant-variable'],
  },

  {
    _id: 'Laptop_3',
    _class: 'Goals',
    courseGroup: 'Laptop',
    goalNumber: '3',
    goalTitle: 'Wärmeenergie (Wissen)',
    goalText:
      'Fachwissen zur Thermischen Energie: SuS können den Begriff "Thermische Energie" / "Wärmeenergie" verwenden oder Indikatoren für Wärmeenergie (wie z.B. Temperatur oder warm/heiß/kalt) verwenden.',
    goalLevel: '0',
    oldNLPgoals: ['M.Thermal-Energy', 'M.Thermal-variable'],
  },

  {
    _id: 'Laptop_4',
    _class: 'Goals',
    courseGroup: 'Laptop',
    goalNumber: '4',
    goalTitle: 'Umwandlung (Wissen)',
    goalText:
      'Fachwissen zur Energieumwandlung. SuS können den Begriff “Umwandlung” oder "Transformation" o.ä. verwenden.',
    goalLevel: '0',
    oldNLPgoals: ['T.Process'],
  },

  {
    _id: 'Laptop_5',
    _class: 'Goals',
    courseGroup: 'Laptop',
    goalNumber: '5',
    goalTitle: 'Erklären',
    goalText: 'SuS können (wissenschaftlich) erklären.',
    goalLevel: '0',
    oldNLPgoals: ['Constructing explanations'],
  },

  {
    _id: 'Laptop_6',
    _class: 'Goals',
    courseGroup: 'Laptop',
    goalNumber: '6',
    goalTitle: 'Versuche planen',
    goalText: 'SuS können Versuche planen.',
    goalLevel: '0',
    oldNLPgoals: ['Planning investigations'],
  },
  {
    _id: 'Laptop_7',
    _class: 'Goals',
    courseGroup: 'Laptop',
    goalNumber: '7',
    goalTitle: 'Daten auswerten',
    goalText: 'SuS können Daten auswerten.',
    goalLevel: '0',
    oldNLPgoals: ['Analyzing data'],
  },

  {
    _id: 'Laptop_8',
    _class: 'Goals',
    courseGroup: 'Laptop',
    goalNumber: '8',
    goalTitle: 'Energieformen (Kompetenz)',
    goalText:
      'Kompetenzen zu Energieformen: SuS können Energieformen in verschiedenen Phänomenen benennen/beschreiben.',
    goalLevel: '1',
    oldNLPgoals: ['M1', 'M2', 'M3', 'M4'],
  },

  {
    _id: 'Laptop_9',
    _class: 'Goals',
    courseGroup: 'Laptop',
    goalNumber: '9',
    goalTitle: 'Umwandlung (Kompetenz)',
    goalText:
      'Kompetenzen zur Energieumwandlung: SuS können EnergieUmwandlung in verschiedenen Phänomenen benennen/beschreiben.',
    goalLevel: '1',
    oldNLPgoals: ['T1'],
  },

  {
    _id: 'Solarzellen_1',
    _class: 'Goals',
    courseGroup: 'Solarzellen',
    goalNumber: '1',
    goalTitle: 'Elektrische Energie (Wissen)',
    goalText:
      'Fachwissen zur elektrischen Energie: SuS können den Begriff "Elektrische Energie" verwenden oder Indikatoren für Elektische Energie (wie z.B. Strom) verwenden.',
    goalLevel: '0',
    oldNLPgoals: ['M.Electric-Energy', 'M.Electric-variable'],
  },

  {
    _id: 'Solarzellen_2',
    _class: 'Goals',
    courseGroup: 'Solarzellen',
    goalNumber: '2',
    goalTitle: 'Strahlungsenergie (Wissen)',
    goalText:
      'Fachwissen zur Strahlungsenergie: SuS können den Begriff "Strahlungsenergie" verwenden oder Indikatoren für Strahlungsenergie (wie z.B. Licht) verwenden.',
    goalLevel: '0',
    oldNLPgoals: ['M.Radiant-Energy', 'M.Radiant-variable'],
  },

  {
    _id: 'Solarzellen_3',
    _class: 'Goals',
    courseGroup: 'Solarzellen',
    goalNumber: '3',
    goalTitle: 'Umwandlung (Wissen)',
    goalText:
      'Fachwissen zur Energieumwandlung. SuS können den Begriff “Umwandlung” oder "Transformation" o.ä. verwenden.',
    goalLevel: '0',
    oldNLPgoals: ['T.Process'],
  },

  {
    _id: 'Solarzellen_4',
    _class: 'Goals',
    courseGroup: 'Solarzellen',
    goalNumber: '4',
    goalTitle: 'Erklären',
    goalText: 'SuS können (wissenschaftlich) erklären.',
    goalLevel: '0',
    oldNLPgoals: ['Constructing explanations'],
  },
  {
    _id: 'Solarzellen_5',
    _class: 'Goals',
    courseGroup: 'Solarzellen',
    goalNumber: '5',
    goalTitle: 'Versuche planen',
    goalText: 'SuS können Versuche planen.',
    goalLevel: '0',
    oldNLPgoals: ['Planning investigations'],
  },
  {
    _id: 'Solarzellen_6',
    _class: 'Goals',
    courseGroup: 'Solarzellen',
    goalNumber: '6',
    goalTitle: 'Daten auswerten',
    goalText: 'SuS können Daten auswerten.',
    goalLevel: '0',
    oldNLPgoals: ['Analyzing data'],
  },

  {
    _id: 'Solarzellen_7',
    _class: 'Goals',
    courseGroup: 'Solarzellen',
    goalNumber: '7',
    goalTitle: 'Energieformen (Kompetenz)',
    goalText:
      'Kompetenzen zu Energieformen: SuS können Energieformen in verschiedenen Phänomenen benennen/beschreiben.',
    goalLevel: '1',
    oldNLPgoals: ['M1', 'M2', 'M3', 'M4'],
  },

  {
    _id: 'Solarzellen_8',
    _class: 'Goals',
    courseGroup: 'Solarzellen',
    goalNumber: '8',
    goalTitle: 'Umwandlung (Kompetenz)',
    goalText:
      'Kompetenzen zur Energieumwandlung: SuS können Energieumwandlung in verschiedenen Phänomenen benennen/beschreiben.',
    goalLevel: '1',
    oldNLPgoals: ['T1'],
  },
];

// old Task-to-Goal Mapping. Maybe needed for later (see old Task-to-Goal Mapping.json)
// export const taskDocs = [
//   {
//     _id: '1',
//     _class: 'Tasks',
//     taskName: 'Laptop_ProblemeeinesLaptops_0',
//     courseGroup: 'Laptop',
//     moodleTaskId: '01',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '2',
//     _class: 'Tasks',
//     taskName: 'Laptop_ErklärungendesheißwerdendenLaptops_0',
//     courseGroup: 'Laptop',
//     moodleTaskId: '02',
//     goalids: [1, 2, 4, 5, 6, 8, 10],
//     taskType: 'essay',
//   },
//   {
//     _id: '3',
//     _class: 'Tasks',
//     taskName: 'Laptop_AufschraubeneinesLaptops_1',
//     courseGroup: 'Laptop',
//     moodleTaskId: '03',
//     goalids: [5],
//     taskType: 'essay',
//   },
//   {
//     _id: '4',
//     _class: 'Tasks',
//     taskName: 'Laptop_EinheißesElementimLaptop_0',
//     courseGroup: 'Laptop',
//     moodleTaskId: '04',
//     goalids: [2],
//     taskType: 'multichoice',
//   },
//   {
//     _id: '5',
//     _class: 'Tasks',
//     taskName: 'Laptop_Stromkreisexperiment(ExperimentfürSchüler/innen)_1',
//     courseGroup: 'Laptop',
//     moodleTaskId: '05',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '6',
//     _class: 'Tasks',
//     taskName: 'Laptop_Stromkreisexperiment(ExperimentfürSchüler/innen)_2',
//     courseGroup: 'Laptop',
//     moodleTaskId: '06',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '7',
//     _class: 'Tasks',
//     taskName: 'Laptop_Stromkreisexperiment(ExperimentfürSchüler/innen)_3',
//     courseGroup: 'Laptop',
//     moodleTaskId: '07',
//     goalids: [3, 1, 4],
//     taskType: 'multichoice',
//   },
//   {
//     _id: '8',
//     _class: 'Tasks',
//     taskName: 'Laptop_Stromkreisexperiment(ExperimentfürSchüler/innen)_4',
//     courseGroup: 'Laptop',
//     moodleTaskId: '08',
//     goalids: [1, 2, 4, 5, 6, 8, 10],
//     taskType: 'essay',
//   },
//   {
//     _id: '9',
//     _class: 'Tasks',
//     taskName: 'Laptop_1.Zusammenfassung_0',
//     courseGroup: 'Laptop',
//     moodleTaskId: '09',
//     goalids: [2, 5],
//     taskType: 'essay',
//   },
//   {
//     _id: '10',
//     _class: 'Tasks',
//     taskName: 'Laptop_WannwirdeinLaptopmanchmalheiß?_0',
//     courseGroup: 'Laptop',
//     moodleTaskId: '10',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '11',
//     _class: 'Tasks',
//     taskName: 'Laptop_ExperimentineinemStromkreis2.0(Schülerexperiment)_1',
//     courseGroup: 'Laptop',
//     moodleTaskId: '11',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '12',
//     _class: 'Tasks',
//     taskName: 'Laptop_ExperimentineinemStromkreis2.0(Schülerexperiment)_2',
//     courseGroup: 'Laptop',
//     moodleTaskId: '12',
//     goalids: [1, 2, 4, 5, 6, 8, 10],
//     taskType: 'essay',
//   },
//   {
//     _id: '13',
//     _class: 'Tasks',
//     taskName: 'Laptop_ExperimentineinemStromkreis2.0(Demonstrationsexperiment)_1',
//     courseGroup: 'Laptop',
//     moodleTaskId: '13',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '14',
//     _class: 'Tasks',
//     taskName: 'Laptop_ExperimentineinemStromkreis2.0(Demonstrationsexperiment)_2',
//     courseGroup: 'Laptop',
//     moodleTaskId: '14',
//     goalids: [1, 2, 4, 5, 6, 8, 10],
//     taskType: 'essay',
//   },
//   {
//     _id: '15',
//     _class: 'Tasks',
//     taskName: 'Laptop_2.Zusammenfassung_0',
//     courseGroup: 'Laptop',
//     moodleTaskId: '15',
//     goalids: [1, 2, 4, 5, 6, 8, 10],
//     taskType: 'essay',
//   },
//   {
//     _id: '16',
//     _class: 'Tasks',
//     taskName: 'Laptop_EinwichtigesBauteilimLaptop(ExperimentfürSchüler/innen)_2',
//     courseGroup: 'Laptop',
//     moodleTaskId: '16',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '17',
//     _class: 'Tasks',
//     taskName: 'Laptop_EinwichtigesBauteilimLaptop(ExperimentfürSchüler/innen)_3',
//     courseGroup: 'Laptop',
//     moodleTaskId: '17',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '18',
//     _class: 'Tasks',
//     taskName: 'Laptop_EinwichtigesBauteilimLaptop(ExperimentfürSchüler/innen)_4',
//     courseGroup: 'Laptop',
//     moodleTaskId: '18',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '19',
//     _class: 'Tasks',
//     taskName: 'Laptop_EinwichtigesBauteilimLaptop(ExperimentfürSchüler/innen)_5',
//     courseGroup: 'Laptop',
//     moodleTaskId: '19',
//     goalids: [1, 2, 4, 5, 6, 8, 10],
//     taskType: 'essay',
//   },
//   {
//     _id: '20',
//     _class: 'Tasks',
//     taskName: 'CRU04_Ein wichtiges Bauteil im Laptop (Demonstrationsexperiment)_2',
//     courseGroup: 'Laptop',
//     moodleTaskId: '20',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '21',
//     _class: 'Tasks',
//     taskName: 'CRU04_Ein wichtiges Bauteil im Laptop (Demonstrationsexperiment)_3',
//     courseGroup: 'Laptop',
//     moodleTaskId: '21',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '22',
//     _class: 'Tasks',
//     taskName: 'CRU06_Ein wichtiges Bauteil im Laptop (Demonstrationsexperiment)_4',
//     courseGroup: 'Laptop',
//     moodleTaskId: '22',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '23',
//     _class: 'Tasks',
//     taskName: 'CRU04_Ein wichtiges Bauteil im Laptop (Demonstrationsexperiment)_5',
//     courseGroup: 'Laptop',
//     moodleTaskId: '23',
//     goalids: [1, 2, 4, 5, 6, 8, 10],
//     taskType: 'essay',
//   },
//   {
//     _id: '24',
//     _class: 'Tasks',
//     taskName: 'Laptop_FrühereLaptopsvs.heutigeLaptops_0',
//     courseGroup: 'Laptop',
//     moodleTaskId: '24',
//     goalids: [],
//     taskType: 'gapselect',
//   },
//   {
//     _id: '25',
//     _class: 'Tasks',
//     taskName: 'Laptop_3.Zusammenfassung_0',
//     courseGroup: 'Laptop',
//     moodleTaskId: '25',
//     goalids: [1, 2, 4, 5, 6, 7, 10],
//     taskType: 'essay',
//   },
//   {
//     _id: '26',
//     _class: 'Tasks',
//     taskName: 'Laptop_Zusammenfassung_0',
//     courseGroup: 'Laptop',
//     moodleTaskId: '26',
//     goalids: [1, 2, 4, 5, 6, 9, 10],
//     taskType: 'essay',
//   },
//   {
//     _id: '27',
//     _class: 'Tasks',
//     taskName: 'Laptop_Zusammenfassung_1',
//     courseGroup: 'Laptop',
//     moodleTaskId: '27',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '28',
//     _class: 'Tasks',
//     taskName: 'Laptop_Zusammenfassung_2',
//     courseGroup: 'Laptop',
//     moodleTaskId: '28',
//     goalids: [],
//     taskType: 'multichoice',
//   },
//   {
//     _id: '29',
//     _class: 'Tasks',
//     taskName: 'Laptop_Zusammenfassung_3',
//     courseGroup: 'Laptop',
//     moodleTaskId: '29',
//     goalids: [4, 1, 6],
//     taskType: 'multichoice',
//   },
//   {
//     _id: '30',
//     _class: 'Tasks',
//     taskName: 'Laptop_Zusammenfassung_4',
//     courseGroup: 'Laptop',
//     moodleTaskId: '30',
//     goalids: [6],
//     taskType: 'multichoice',
//   },
//   {
//     _id: '31',
//     _class: 'Tasks',
//     taskName: 'Laptop_Zusammenfassung_5',
//     courseGroup: 'Laptop',
//     moodleTaskId: '31',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '32',
//     _class: 'Tasks',
//     taskName: 'Solarzelle_HäusermitSolarzellen_1',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '01',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '33',
//     _class: 'Tasks',
//     taskName: 'Solarzelle_Erklärungfür einemöglichstguteEnergieumwandlung_0',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '02',
//     goalids: [3, 4, 1, 5, 6, 10],
//     taskType: 'essay',
//   },
//   {
//     _id: '34',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_ExperimentmiteinerSolarzelle_0',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '03',
//     goalids: [3, 1, 5],
//     taskType: 'gapselect',
//   },
//   {
//     _id: '35',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_ExperimentmiteinerSolarzelle_2',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '04',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '36',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_ExperimentmiteinerSolarzelle_3',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '05',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '37',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_ExperimentmiteinerSolarzelle_4',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '06',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '38',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_ExperimentmiteinerSolarzelle_5',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '07',
//     goalids: [3, 4, 1, 2, 5],
//     taskType: 'multianswer',
//   },
//   {
//     _id: '39',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_1.Zusammenfassung_0',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '08',
//     goalids: [3, 4, 1, 5, 6, 10],
//     taskType: 'essay',
//   },
//   {
//     _id: '40',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_ExperimentzurAusrichtungvonSolarzellen_1',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '09',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '41',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_ExperimentzurAusrichtungvonSolarzellen_2',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '10',
//     goalids: [3, 4, 1, 2, 5, 8, 10],
//     taskType: 'essay',
//   },
//   {
//     _id: '42',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_ExperimentzurAusrichtungvonSolarzellen_3(Schülerexperiment)_1',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '11',
//     goalids: [3, 4],
//     taskType: 'essay',
//   },
//   {
//     _id: '43',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_ExperimentzurAusrichtungvonSolarzellen_4(Schülerexperiment)_2',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '12',
//     goalids: [3, 4],
//     taskType: 'essay',
//   },
//   {
//     _id: '44',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_ExperimentzurAusrichtungvonSolarzellen_5(Demonstrationsexperiment)_1',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '13',
//     goalids: [3, 4],
//     taskType: 'essay',
//   },
//   {
//     _id: '45',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_ExperimentzurAusrichtungvonSolarzellen_6(Demonstrationsexperiment)_2',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '14',
//     goalids: [3, 4],
//     taskType: 'essay',
//   },
//   {
//     _id: '46',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_ExperimentzurAusrichtungvonSolarzellen_7',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '15',
//     goalids: [3, 4, 6],
//     taskType: 'essay',
//   },
//   {
//     _id: '47',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_QuizzurAusrichtungvonSolarzellen_0',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '16',
//     goalids: [3, 4],
//     taskType: 'multianswer',
//   },
//   {
//     _id: '48',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_2.Zusammenfassung_0',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '17',
//     goalids: [3, 4, 7],
//     taskType: 'essay',
//   },
//   {
//     _id: '49',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_ExperimentzurNachrichtungvonSolarzellen_0',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '18',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '50',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_ExperimentzurNachrichtungvonSolarzellen_1',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '19',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '51',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_ExperimentzurNachrichtungvonSolarzellen_2',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '20',
//     goalids: [3, 4, 1, 2, 5, 8, 10],
//     taskType: 'essay',
//   },
//   {
//     _id: '52',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_ExperimentzurVerschattungvonSolarzellen_0',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '21',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '53',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_ExperimentzurVerschattungvonSolarzellen_1',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '22',
//     goalids: [],
//     taskType: 'essay',
//   },
//   {
//     _id: '54',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_ExperimentzurVerschattungvonSolarzellen_2',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '23',
//     goalids: [3, 4, 1, 2, 5, 8, 10],
//     taskType: 'essay',
//   },
//   {
//     _id: '55',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_QuizzurVerschattungvonSolarzellen_1',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '24',
//     goalids: [3, 4],
//     taskType: 'truefalse',
//   },
//   {
//     _id: '56',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_QuizzurVerschattungvonSolarzellen_2',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '25',
//     goalids: [3, 4],
//     taskType: 'truefalse',
//   },
//   {
//     _id: '57',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_QuizzurVerschattungvonSolarzellen_3',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '26',
//     goalids: [3, 4],
//     taskType: 'truefalse',
//   },
//   {
//     _id: '58',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_QuizzurVerschattungvonSolarzellen_4',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '27',
//     goalids: [3, 4],
//     taskType: 'truefalse',
//   },
//   {
//     _id: '59',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_QuizzurVerschattungvonSolarzellen_5',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '28',
//     goalids: [3, 4],
//     taskType: 'truefalse',
//   },
//   {
//     _id: '60',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_QuizzurVerschattungvonSolarzellen_6',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '29',
//     goalids: [3, 4],
//     taskType: 'truefalse',
//   },
//   {
//     _id: '61',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_QuizzurVerschattungvonSolarzellen_7',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '30',
//     goalids: [3, 4],
//     taskType: 'truefalse',
//   },
//   {
//     _id: '62',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_QuizzurVerschattungvonSolarzellen_8',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '31',
//     goalids: [3, 4],
//     taskType: 'truefalse',
//   },
//   {
//     _id: '63',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_3.Zusammenfassung_0',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '32',
//     goalids: [3, 4, 1, 2, 5, 8, 10],
//     taskType: 'essay',
//   },
//   {
//     _id: '64',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_Zusammenfassung_0',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '33',
//     goalids: [3, 4, 1, 2, 5, 9, 10],
//     taskType: 'essay',
//   },
//   {
//     _id: '65',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_Zusammenfassung_2',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '34',
//     goalids: [3, 1, 5],
//     taskType: 'multichoice',
//   },
//   {
//     _id: '66',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_Zusammenfassung_1',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '35',
//     goalids: [3, 1, 5],
//     taskType: 'multichoice',
//   },
//   {
//     _id: '67',
//     _class: 'Tasks',
//     taskName: 'Solarzellen_Zusammenfassung_3',
//     courseGroup: 'Solarzellen',
//     moodleTaskId: '36',
//     goalids: [],
//     taskType: 'essay',
//   },
// ];

// export const goalDocs = [
//   {
//     _id: 'Laptop' + '_' + '1',
//     _class: 'Goals',
//     courseGroup: 'Laptop',
//     goalNumber: '1',
//     goalTitle: 'M.Electric-Energy',
//     goalText: 'M.Electric-Energy: Students name electric energy.',
//     goalLevel: '0',
//   },
//   {
//     _id: 'Laptop' + '_' + '2',
//     _class: 'Goals',
//     courseGroup: 'Laptop',
//     goalNumber: '2',
//     goalTitle: 'M.Electric-variable',
//     goalText: 'M.Electric-variable: Students name variables of electric energy.',
//     goalLevel: '0',
//   },

//   {
//     _id: 'Laptop' + '_' + '3',
//     _class: 'Goals',
//     courseGroup: 'Laptop',
//     goalNumber: '3',
//     goalTitle: 'M.Radiant-Energy',
//     goalText: 'M.Radiant-Energy: Students name radiant energy.',
//     goalLevel: '0',
//   },
//   {
//     _id: 'Laptop' + '_' + '4',
//     _class: 'Goals',
//     courseGroup: 'Laptop',
//     goalNumber: '4',
//     goalTitle: 'M.Thermal-Energy',
//     goalText: 'M.Thermal-Energy: Students name thermal energy.',
//     goalLevel: '0',
//   },
//   {
//     _id: 'Laptop' + '_' + '5',
//     _class: 'Goals',
//     courseGroup: 'Laptop',
//     goalNumber: '5',
//     goalTitle: 'M.Thermal-variable',
//     goalText: 'M.Thermal-variable: Students name varialbes of thermal energy.',
//     goalLevel: '0',
//   },

//   {
//     _id: 'Laptop' + '_' + '6',
//     _class: 'Goals',
//     courseGroup: 'Laptop',
//     goalNumber: '6',
//     goalTitle: 'T.Process',
//     goalText: 'T.Process: Students use the term “Umwandlung” or "Transformation" similar in their answers.',
//     goalLevel: '0',
//   },
//   {
//     _id: 'Laptop' + '_' + '7',
//     _class: 'Goals',
//     courseGroup: 'Laptop',
//     goalNumber: '7',
//     goalTitle: 'M1_04_b',
//     goalText: 'M1_04_b: Students identify thermal energy based on its variables.',
//     goalLevel: '1',
//   },
//   {
//     _id: 'Laptop' + '_' + '8',
//     _class: 'Goals',
//     courseGroup: 'Laptop',
//     goalNumber: '8',
//     goalTitle: 'M3_04_a',
//     goalText: 'M3_04_a: Students identify electric and thermal energy based on their variables.',
//     goalLevel: '1',
//   },
//   {
//     _id: 'Laptop' + '_' + '9',
//     _class: 'Goals',
//     courseGroup: 'Laptop',
//     goalNumber: '9',
//     goalTitle: 'M4_04_a',
//     goalText:
//       'M4_04_a: Students reason for experiment leads not getting warm, warming up of the laptop or explanations of observations with at least two variables for one of the energy forms and at least one variable for both of the energy forms.',
//     goalLevel: '1',
//   },
//   {
//     _id: 'Laptop' + '_' + '10',
//     _class: 'Goals',
//     courseGroup: 'Laptop',
//     goalNumber: '10',
//     goalTitle: 'T1_04_a',
//     goalText:
//       'T1_04_a: Students identify one energy transformation between two different forms of energy, namely between thermal energy and electric energy.',
//     goalLevel: '1',
//   },

//   {
//     _id: 'Solarzellen' + '_' + '1',
//     _class: 'Goals',
//     courseGroup: 'Solarzellen',
//     goalNumber: '1',
//     goalTitle: 'M.Electric-Energy',
//     goalText: 'M.Electric-Energy: Students name electric energy.',
//     goalLevel: '0',
//   },

//   {
//     _id: 'Solarzellen' + '_' + '2',
//     _class: 'Goals',
//     courseGroup: 'Solarzellen',
//     goalNumber: '2',
//     goalTitle: 'M.Electric-variable',
//     goalText: 'M.Electric-variable: Students name variables of electric energy.',
//     goalLevel: '0',
//   },

//   {
//     _id: 'Solarzellen' + '_' + '3',
//     _class: 'Goals',
//     courseGroup: 'Solarzellen',
//     goalNumber: '3',
//     goalTitle: 'M.Radiant-Energy',
//     goalText: 'M.Radiant-Energy: Students name radiant energy.',
//     goalLevel: '0',
//   },
//   {
//     _id: 'Solarzellen' + '_' + '4',
//     _class: 'Goals',
//     courseGroup: 'Solarzellen',
//     goalNumber: '4',
//     goalTitle: 'M.Radiant-variable',
//     goalText: 'M.Radiant-variable: Students name variables radiant energy.',
//     goalLevel: '0',
//   },
//   {
//     _id: 'Solarzellen' + '_' + '5',
//     _class: 'Goals',
//     courseGroup: 'Solarzellen',
//     goalNumber: '5',
//     goalTitle: 'T.Process',
//     goalText: 'T.Process: Students use the term “Umwandlung” or "Transformation" similar in their answers.',
//     goalLevel: '0',
//   },

//   {
//     _id: 'Solarzellen' + '_' + '6',
//     _class: 'Goals',
//     courseGroup: 'Solarzellen',
//     goalNumber: '6',
//     goalTitle: 'M1_05_a',
//     goalText: 'M1_05_a: Students identify radiant energy based on its variables.',
//     goalLevel: '1',
//   },

//   {
//     _id: 'Solarzellen' + '_' + '7',
//     _class: 'Goals',
//     courseGroup: 'Solarzellen',
//     goalNumber: '7',
//     goalTitle: 'M2_05_a',
//     goalText: 'M2_05_a: Students reason for a maximum of radiant energy with at least two variables.',
//     goalLevel: '1',
//   },
//   {
//     _id: 'Solarzellen' + '_' + '8',
//     _class: 'Goals',
//     courseGroup: 'Solarzellen',
//     goalNumber: '8',
//     goalTitle: 'M3_05_a',
//     goalText: 'M3_05_a: Students identify radiant and electric energy based on their variables.',
//     goalLevel: '1',
//   },
//   {
//     _id: 'Solarzellen' + '_' + '9',
//     _class: 'Goals',
//     courseGroup: 'Solarzellen',
//     goalNumber: '9',
//     goalTitle: 'M4_05_a',
//     goalText:
//       'M4_05_a: Students reason for a maximum of radiant and electric energy with at least two variables for one of the energy forms and at least one variable for both of the energy forms.',
//     goalLevel: '1',
//   },
//   {
//     _id: 'Solarzellen' + '_' + '10',
//     _class: 'Goals',
//     courseGroup: 'Solarzellen',
//     goalNumber: '10',
//     goalTitle: 'T1_05_a',
//     goalText:
//       'T1_05_a: Students identify one energy transformation between two different forms of energy, namely between radiant energy and electric energy.',
//     goalLevel: '1',
//   },
// ];
